<template>
  <transition name="fade">
    <div class="black-friday" v-if="visibleBlackFridayPopup">
      <div class="black-friday-shadow" @click="hideBlackFridayPopup"></div>
      <div class="black-friday-scroll" @click="hideBlackFridayPopup">
        <div class="black-friday-main" @click="mainContClick">
          <a
            href="javascript:;"
            class="main-close"
            @click="hideBlackFridayPopup"
          ></a>
          <div class="main-title">
            <div class="main-title-bg"></div>
            <p class="main-title-text">{{ letter.blackFridayDiscount }}</p>
          </div>
          <p class="main-left-time">
            <span>{{ letter.timeLeft }} </span>
            {{ bfTime.days }}
            <span class="time">d</span>
            {{ bfTime.hours }}
            <span class="time">h</span>
            {{ bfTime.minutes }}
            <span class="time">m</span>
          </p>
          <div class="main-discount">
            <div class="divider"></div>
            <p class="discount-text">{{ letter.limitedTimeOff }}</p>
            <div class="divider"></div>
          </div>
          <div class="main-exchange-box">
            <div
              class="hidden"
              @click="setCodeInputStatus(true)"
              v-show="!isShowCodeInput"
            >
              <em class="ico"></em>
              <span class="text">{{ letter.exchangeCode }}</span>
            </div>
            <div class="show" v-show="isShowCodeInput">
              <div class="show-btn" @click="setCodeInputStatus(false)">
                <em class="ico"></em>
                <span class="text">{{ letter.hideText }}</span>
              </div>
              <div class="exchange-box">
                <input
                  type="text"
                  class="score-input"
                  :placeholder="letter.enterExchangeCode"
                  v-model="scoreCode"
                />
                <a class="score-btn" href="javascript:;" @click="getScore">{{
                  letter.exchangeText
                }}</a>
              </div>
              <p class="exchange-tips" v-show="isShowExchangeSuccTip">
                <em class="succ-ico"></em>
                <span class="succ-text">{{ letter.exchangeSucc }}</span>
              </p>
              <p class="exchange-tips" v-show="isShowExchangeFailTip">
                <em class="fail-ico"></em>
                <span class="fail-text">{{ codeTips }}</span>
              </p>
            </div>
          </div>
          <p class="main-left-points">
            {{ letter.points.replace('${point}', curScore) }}
          </p>
          <div class="main-progress-bg">
            <div
              class="main-progress"
              :style="`width:${(curScore / 500) * 100}%`"
            ></div>
          </div>
          <p class="main-points-tips">
            {{ letter.costPointTip }} {{ letter.maxPointTip }}
          </p>
          <div class="main-discount-group">
            <div
              v-for="(item, index) in couponList"
              :key="index"
              class="discount-item"
              :class="{ disabled: item.cost > curScore }"
              @click="chooseCouponLevel(index)"
            >
              <div class="discount-content">
                <p class="discount-rate">{{ letter.discountOff }}</p>
                <p class="discount-money">
                  {{
                    letter.highestDiscount.replace(
                      '${discount}',
                      `${couponDiscount[currency][index]} ${currency}`
                    )
                  }}
                </p>
                <p class="discount-cost">
                  {{ letter.needPoint.replace('${point}', item.cost) }}
                </p>
              </div>
              <div :class="{ active: curCouponLevel === index }"></div>
            </div>
          </div>
          <template v-if="showShare">
            <div class="main-share-box">
              <p class="share-text">{{ letter.thanksTip }}</p>
              <div class="share-btn-group">
                <a
                  v-if="gameId == 191 && lang == 'ja-JP'"
                  href="javascript:;"
                  class="share-btn facebook"
                  @click="shareTwitter"
                  >Twitter</a
                >
                <a
                  v-else
                  href="javascript:;"
                  class="share-btn facebook"
                  @click="shareFacebook"
                  >Facebook</a
                >
                <a
                  href="javascript:;"
                  class="share-btn discord"
                  @click="shareDiscord"
                  >Discord</a
                >
              </div>
              <p class="share-footer">{{ letter.footTips3 }}</p>
            </div>
          </template>
          <template v-else>
            <div class="main-choose-coins">
              <Select
                type="selectProductOrder"
                icon="selectvh"
                rightSpan="43px"
                class="choose-coins-type"
                v-model="currency"
              >
                <template slot="option">
                  <option
                    v-for="item in currencyOption"
                    :key="item.label"
                    :value="item.value"
                  >
                    {{ item.label }}
                  </option>
                </template>
                <template slot="ico">
                  <em class="ico"></em>
                </template>
              </Select>
            </div>
            <p class="main-point-left" v-if="getCouponAble">
              {{
                letter.afterClaimPoint.replace(
                  '${point}',
                  curScore - couponList[curCouponLevel].cost
                )
              }}
            </p>
            <p class="main-point-left" v-else>
              <span class="not-enough"></span>{{ letter.pointNotEnough }}
            </p>
            <a
              href="javascript:;"
              class="get-coupon-btn"
              :class="{ disabled: !getCouponAble }"
              @click="getCoupon"
              >{{ letter.claim }}</a
            >
            <div class="main-footer-group">
              <p>* {{ letter.footTips1 }}</p>
              <p>* {{ letter.footTips2 }}</p>
              <p style="opacity: 0.4">{{ letter.footTips3 }}</p>
            </div>
          </template>
        </div>
      </div>

      <PopupWindow
        @onCancel="showTipPopup = false"
        @onConfirm="showTipPopup = false"
        type="tips"
        textAlign="center"
        v-if="showTipPopup"
        :languages="letter"
        :content="tips"
      ></PopupWindow>
    </div>
  </transition>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex';
import { SET_VISIBLE_BLACK_FRIDAY_POPUP } from '@store/officialStore/index';
import { getDefaultPayType } from '@store/officialStore/storager';
import { blackFridayCurrencyList } from '@store/officialStore/coins';
import {
  BLACK_FRIDAY_GET_SCORE,
  BLACK_FRIDAY_EXCHANGE
} from '@store/officialStore/event';
import showWelfare from '@mixins/officialStore/showWelfare';
import { countDownTimeFormat } from '@utiles/officialStore';

export default {
  name: 'blackFridayPopup',
  mixins: [showWelfare],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowCodeInput: false,
      scoreCode: '',
      isShowExchangeSuccTip: false,
      isShowExchangeFailTip: false,

      currency: '', // 选择的币种
      curCouponLevel: 0,
      showTipPopup: false,
      tips: '',
      codeTips: '',
      couponList: [
        {
          discount: 0.49,
          cost: 5
        },
        {
          discount: 0.99,
          cost: 10
        },
        {
          discount: 1.49,
          cost: 15
        },
        {
          discount: 1.99,
          cost: 20
        },
        {
          discount: 2.99,
          cost: 30
        },
        {
          discount: 3.99,
          cost: 40
        },
        {
          discount: 4.99,
          cost: 50
        },
        {
          discount: 9.99,
          cost: 100
        }
      ],
      couponDiscount: {
        AUD: [0.79, 1.59, 2.29, 3.09, 4.59, 6.09, 7.69, 15.49],
        CAD: [0.49, 1.39, 2.09, 2.79, 3.99, 5.49, 6.99, 13.99],
        GBP: [0.49, 0.99, 1.29, 1.99, 2.99, 3.99, 4.99, 9.99],
        EUR: [0.49, 0.95, 1.39, 1.89, 2.79, 3.69, 4.59, 9.19],
        HKD: [4.0, 8.0, 12.0, 15.0, 23.0, 28.0, 38.0, 78.0],
        IDR: [
          4000.0, 16000.0, 24000.0, 35000.0, 49000.0, 65000.0, 79000.0, 159000.0
        ],
        JPY: [70.0, 160.0, 230.0, 320.0, 480.0, 650.0, 800.0, 1600.0],
        KRW: [500.0, 1500.0, 2100.0, 3000.0, 4400.0, 6000.0, 7500.0, 15000.0],
        MYR: [1.0, 4.9, 7.5, 9.9, 13.9, 18.9, 23.9, 44.9],
        PLN: [1.99, 3.99, 5.99, 7.99, 11.99, 15.99, 19.99, 40.49],
        RUB: [20.0, 99.0, 140.0, 179.0, 279.0, 379.0, 449.0, 899.0],
        THB: [15.0, 35.0, 55.0, 69.0, 99.0, 149.0, 179.0, 349.0],
        TWD: [19.0, 33.0, 49.0, 70.0, 100.0, 130.0, 170.0, 330.0],
        USD: [0.49, 0.99, 1.49, 1.99, 2.99, 3.99, 4.99, 9.99]
      },
      jumpLink: {
        191: {
          facebookGlobal: window.atob('aHR0cHM6Ly93d3cuZmFjZWJvb2suY29tL1BuUy4zN0dhbWVzLw=='),
          'facebookko-KR': 'https://www.facebook.com/puzzleofZ.KR/',
          'facebookzh-TW': 'https://www.facebook.com/PnS.TW',
          discord: 'https://discord.com/invite/puzzlesandsurvival',
          twitter: window.atob('aHR0cHM6Ly90d2l0dGVyLmNvbS8zN2dhbWVzX3Buc2pw')
        },
        263: {
          facebookGlobal: 'https://www.facebook.com/groups/745855496766211',
          discord: 'https://discord.gg/vaNw6WGcBJ'
        }
      },
      isReqGetCoupon: false
    };
  },
  computed: {
    ...mapState({
      welfareBtnRecord: state => state.welfareBtnRecord,
      letter: state => state.letter,
      lang: state => state.lang,
      gameId: state => state.gameId,
      visibleBlackFridayPopup: state => state.visibleBlackFridayPopup,
      curScore: state => state.event.bfScore,
      lastPayCurrency: state => state.lastPayCurrency
    }),
    ...mapGetters(['gameInfoConfig']),
    getCouponAble() {
      return this.curScore - this.couponList[this.curCouponLevel].cost >= 0;
    },
    showShare() {
      return this.curScore == 0;
    },
    bfTime() {
      const { days, hours, minutes } = countDownTimeFormat(
        this.$store.state.event.bfTime
      );
      return {
        days,
        hours,
        minutes
      };
    },
    currencyOption() {
      return blackFridayCurrencyList.map(item => {
        return {
          label: `${item}【${this.letter.changeCurrency}】`,
          value: item
        };
      });
    }
  },
  methods: {
    ...mapMutations({
      setVisibleBlackFridatPopup: SET_VISIBLE_BLACK_FRIDAY_POPUP
    }),
    mainContClick(e) {
      e?.stopPropagation();
    },
    setCodeInputStatus(status) {
      this.isShowCodeInput = status;
    },
    async getScore() {
      if (!this.scoreCode) return;
      try {
        const res = await this.$store.dispatch(BLACK_FRIDAY_GET_SCORE, {
          code: this.scoreCode
        });
        this.isShowExchangeSuccTip = true;
        this.isShowExchangeFailTip = false;
      } catch (err) {
        this.codeTips = `[${err.code}]${
          this.letter['bf' + err.code] || this.letter['bf-20002']
        }`;
        this.isShowExchangeSuccTip = false;
        this.isShowExchangeFailTip = true;
      }
    },
    hideBlackFridayPopup() {
      this.isShowExchangeSuccTip = false;
      this.isShowExchangeFailTip = false;
      this.isShowCodeInput = false;
      this.isShowExchangeSuccTip = false;
      this.setVisibleBlackFridatPopup(false);
    },
    chooseCouponLevel(index) {
      this.curCouponLevel = index;
    },
    async getCoupon() {
      if (this.isReqGetCoupon) return;
      this.isReqGetCoupon = true;
      try {
        const res = await this.$store.dispatch(BLACK_FRIDAY_EXCHANGE, {
          level: this.curCouponLevel,
          currency: this.currency
        });
        this.tips = this.letter.claimSucc;
        this.showTipPopup = true;
      } catch (err) {
        this.tips = `[${err.code}]${
          this.letter['bf' + err.code] || this.letter['bf-20002']
        }`;
        this.showTipPopup = true;
      }
      this.isReqGetCoupon = false;
    },
    shareTwitter() {
      window.open(this.jumpLink[191]?.twitter, '_blank');
    },
    shareFacebook() {
      const curjumpLink =
        this.jumpLink[this.gameId]?.[`facebook${this.lang}`] ||
        this.jumpLink[this.gameId]?.['facebookGlobal'];
      window.open(curjumpLink, '_blank');
    },
    shareDiscord() {
      window.open(this.jumpLink[this.gameId]?.discord, '_blank');
    }
  },
  watch: {
    lastPayCurrency: {
      handler(val) {
        // 兼容不存在的币种 构建
        if (this.couponDiscount[val]) {
          this.currency = val;
        } else {
          this.currency = 'USD';
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/webStore.scss';
.black-friday {
  z-index: 13;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }
  &-scroll {
    overflow: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    max-height: 100%;
  }
  &-main {
    text-align: center;
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 50px auto;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    @psetbg ('bf-bg-short.png');
    height: 1128px !important;
  }
  .bglong {
    background-size: contain;
    @psetbg ('bf-bg-long.png');
  }
  .main {
    &-close {
      position: absolute;
      right: 25px;
      top: 28px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      @psetbg ('close.png');
    }
    &-title {
      margin: 44px 69px 33px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      &-bg {
        position: absolute;
        @psetbg ('title-bg-bf.png');
      }
      &-text {
        background-image: -webkit-linear-gradient(
          top,
          var(--voucher-title-color-top),
          var(--voucher-title-color-bottom)
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
        font-family: SourceHanSansSC-Heavy;
        font-size: 48px;
        font-weight: bold;
      }
    }
    &-left-time {
      font-family: SourceHanSansCN-Bold;
      font-size: 24px;
      letter-spacing: 0px;
      color: #ffffff;
      .time {
        font-family: SourceHanSansCN-Bold;
        font-size: 18px;
        color: #ffffff;
      }
    }
    &-discount {
      margin-top: 9px;
      .discount-text {
        margin: 16px 44px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        font-size: 53px;
        line-height: 50px;
        letter-spacing: 0px;
        color: #f2cd81;
      }

      .divider {
        margin: 0 44px;
        line-height: 1px;
        border: 1px solid #b8995a;
        opacity: 0.28;
      }
    }
    &-exchange-box {
      margin-top: 23px;
      .hidden {
        cursor: pointer;
        .ico {
          margin-right: 5px;
          display: inline-block;
          @psetbg ('exchange-score-arror.png');
        }
        .text {
          font-size: 16px;
          color: #ffffff;
        }
      }
      .show {
        .show-btn {
          cursor: pointer;
          .ico {
            margin-right: 5px;
            display: inline-block;
            rotate: 180deg;
            @psetbg ('exchange-score-arror.png');
          }
          .text {
            font-size: 16px;
            color: #ffffff;
          }
        }
        .exchange-box {
          margin: 20px 91px 8px;
          display: flex;
          justify-content: center;
          align-items: center;

          .score-input {
            padding: 1px 15px;
            font-size: 18px;
            line-height: 48px;
            color: #999999;
            background-size: 100%;
            @psetbg ('exchange-score-input-bg.png');
            background-color: #161717;
          }
          .score-input::placeholder {
            color: #999999;
          }
          .score-btn {
            margin-left: 5px;
            display: inline-block;
            background-size: cover;
            @psetbg ('exchange-score-btn.png');
            text-align: center;
            font-size: 18px;
            line-height: 50px;
            color: #ffffff;
          }
        }
        .exchange-tips {
          margin: 0 91px;
          text-align: left;
          display: flex;
          align-items: center;
          font-size: 14px;

          .succ-ico {
            margin-right: 5px;
            display: inline-block;
            @psetbg ('exchange-succ-ico.png');
          }
          .fail-ico {
            margin-right: 5px;
            display: inline-block;
            @psetbg ('point-not-enough-icon.png');
          }
          .succ-text {
            color: #c9ae6e;
          }
          .fail-text {
            color: #ffffff;
          }
        }
      }
    }
    &-left-points {
      margin-top: 19px;
      font-family: SourceHanSansCN-Bold;
      font-size: 24px;
      letter-spacing: 0px;
      color: #ffffff;
    }

    &-progress-bg {
      margin: 10px auto;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      @psetbg ('process-bg-bf.png');
      width: 595px;
    }

    &-progress {
      border-radius: 30px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      @psetbg ('process-bf.png');
    }

    &-points-tips {
      margin-top: 23px;
      font-family: SourceHanSansCN-Regular;
      font-size: 16px;
      color: #ffffff;
    }
    &-discount-group {
      margin-top: 14px;

      .discount-item {
        cursor: pointer;
        margin: 0 2px 6px;
        width: 202px;
        height: 122px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        @psetbg ('discount-item.png',false,false);
        text-align: left;
        display: inline-block;
        position: relative;
      }
      .active {
        width: 100%;
        height: 100%;
        position: absolute;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        @psetbg ('discount-item-highlight.png',false,false);
      }
      .disabled {
        pointer-events: none;
        -webkit-filter: grayscale(100%) brightness(50%);
        -moz-filter: grayscale(100%) brightness(50%);
        -ms-filter: grayscale(100%) brightness(50%);
        -o-filter: grayscale(100%) brightness(50%);
        filter: grayscale(100%) brightness(50%);
        -webkit-filter: gray;
        filter: gray;
        -webkit-filter: progid:dximagetransform.microsoft.basicimage(grayscale=1);
        filter: progid:dximagetransform.microsoft.basicimage(grayscale=1);
      }
      .discount-content {
        position: absolute;
        padding: 15px 10px;
        color: #ffffff;
        text-align: left;

        .discount-rate {
          font-weight: bold;
          font-size: 20px;
          color: #c1a15e;
        }
        .discount-money {
          margin-top: 11px;
          font-size: 14px;
        }
        .discount-cost {
          margin-top: 18px;
          font-size: 12px;
        }
      }
    }
    &-share-box {
      margin: 0 20px;
      margin-top: 70px;
      .share-text {
        font-size: 32px;
        color: #ffffff;
      }
      .share-btn-group {
        margin-top: 36px;
        .share-btn {
          margin: 0 8px;
          display: inline-block;
          font-size: 24px;
          color: #fffffe;
          line-height: 60px;
          width: 204px;
          height: 60px;
        }
        .facebook {
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          @psetbg ('share-btn-left.png');
        }
        .discord {
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          @psetbg ('share-btn-right.png');
        }
      }
      .share-footer {
        margin-top: 72px;
        font-size: 14px;
        color: #ffffff;
        opacity: 0.4;
      }
    }

    &-choose-coins {
      margin-top: 20px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;

      .choose-coins-type {
        width: 279px;
        height: 48px;
        border: solid 1px #999999;
        background: rgb(53, 54, 53, 0.2);
        color: #e1e1e1;
        top: 0 !important;
        right: 0;
        position: relative;
        font-size: 18px;
      }
      .ico {
        display: inline-block;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        @psetbg ('search-ico.png');
      }
    }
    &-point-left {
      margin-top: 26px;
      font-family: SourceHanSansCN-Regular;
      font-size: 16px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;

      .not-enough {
        display: inline-block;
        width: 20px;
        height: 21px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        @psetbg ('point-not-enough-icon.png');
      }
    }
    &-footer-group {
      position: absolute;
      right: 31px;
      bottom: 33px;
      text-align: right;
      font-size: 14px;
      color: #ffffff;
      p {
        line-height: 20px;
      }
    }
  }
  .get-coupon-btn {
    margin-top: 11px;
    width: 282px;
    height: 81px;
    display: inline-block;
    font-family: SourceHanSansSC-Medium;
    font-size: 36px;
    line-height: 81px;
    color: #ffffff;
    @psetbg ('get-coupon-btn-bf.png');

    &.disabled {
      pointer-events: none;
      @psetbg ('get-coupon-btn-bf-disabled.png');
    }
  }
}
</style>
